import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

// lazy loaded modules
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "FetchTaggedEmail"*/ "./lazyIndex"), { name: "FetchTaggedEmail" });

export { TAG_EMAIL_HASHTAG } from "./utils/constants";

export const lazyInitializeTaggedEmailsFetch: LazyAction<typeof lazyIndex.initializeTaggedEmailsFetch, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeTaggedEmailsFetch);
